import { createSelector } from 'reselect';

const selectorPickUpStatus = (state: any) => state.PickUpStatusState;

export const makePickUpStatusDocSelector = () =>
  createSelector(selectorPickUpStatus, state => state.pickupStatusDoc);
